import { useContext } from 'react';
import { BreakpointsContext } from '.';

export const useBreakpoints = () => {
	const breakpoints = useContext(BreakpointsContext);
	return breakpoints;
}